import { useEffect, useState } from 'react';
import { trackProductView } from './analytics';

// ── Termékoldal-megtekintés mérése (product_view + view_item) ───────────────
//
// SZEMANTIKA: tényleges termékoldal-megtekintésenként PONTOSAN egyszer.
//   • első megnyitás                          → 1
//   • újrarenderelés / új device-objektum ugyanarra a termékre → nincs újabb
//   • StrictMode dupla effekt (fejlesztői mód) → nincs újabb
//   • termék A → lista → termék A (SPA)       → +1  (új megtekintés)
//   • termék A → termék B, ugyanazon példányon → +1  (a uid a kulcs része)
//   • frissítés                               → +1  (új modul-állapot)
//
// HOGYAN: a `nezet` token MOUNT-onként egyedi (useState lusta inicializálás –
// stabil az újrarenderelések és a StrictMode szimulált újra-mountja alatt,
// de egy valódi új mount új tokent kap). A dedup-kulcs `nezet:uid`, így:
// ugyanaz a megtekintés ugyanazt a kulcsot adja (dedup), egy új megtekintés
// vagy egy másik termék újat. A token és a uid csak BELSŐ kulcs – az eseménybe
// nem kerül; a payload változatlan.
//
// A `cta_view`-tól FÜGGETLEN: az a CTA láthatóságát méri, ez az oldalét.

export default function useProductView(device) {
  const [nezet] = useState(() => Math.random().toString(36).slice(2));
  useEffect(() => {
    if (!device) return;
    trackProductView({
      store: device.store,
      device_id: device.uid,
      model: device.name,
      price: device.rawPrice,
      condition: device.condition,
      battery_health: device.battery,
    }, `${nezet}:${device.uid}`);
  }, [device, nezet]);
}
